import { Button } from '@ophelos/ui/components/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@ophelos/ui/components/dropdown-menu';
import { Check, ChevronDown, X } from 'lucide-react';

import { useAIChat } from '@/contexts/AIChatContext';
import { AGENTS, getAgentConfig } from '../agent-registry';

export function ChatHeader() {
  const { resolvedOpenSource, open, close } = useAIChat();
  const currentAgent = getAgentConfig(resolvedOpenSource);
  const switchableAgents = AGENTS.filter((a) => a.switchable);
  const CurrentIcon = currentAgent.icon;

  return (
    <div className="shrink-0">
      <div className="flex items-center justify-between h-12 ">
        <div className="flex items-center gap-1">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="gap-1.5 text-muted-foreground">
                <CurrentIcon className="opacity-50" />
                <span>{currentAgent.label}</span>
                <ChevronDown className="size-3" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-72 stack gap-1">
              {switchableAgents.map((agent) => {
                const Icon = agent.icon;
                const isActive = agent.source === resolvedOpenSource;
                return (
                  <DropdownMenuItem key={agent.source} onClick={() => open({ source: agent.source })}>
                    <Icon className="size-4 mr-2 shrink-0 opacity-50" />
                    <div>
                      <div className="text-sm font-medium">{agent.label}</div>
                      <div className="text-xs text-muted-foreground">{agent.description}</div>
                    </div>
                    {isActive && (
                      <div className="ml-auto shrink-0 size-5 rounded-full highlight-green flex items-center justify-center">
                        <Check className="size-3" />
                      </div>
                    )}
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <Button variant="ghost" size="icon-sm" className="text-muted-foreground size-7" onClick={close} aria-label="Close AI chat">
          <X className="size-4" />
        </Button>
      </div>
    </div>
  );
}
